module.exports = __webpack_public_path__ + "img/target.4bad2911.png";